import { useMemo } from "react";

import { useTranslation } from "react-i18next";
import Tabs from "../../../../components/Tabs";
import ViewSwitcher from "./ViewSwitcher";

const PreviousMonths = ({ data }) => {
	const { t } = useTranslation();

	const tabs = useMemo(() => {
		return [
			{
				label: t("previous_months"),
				content: <ViewSwitcher data={data} />,
			},
		];
	}, [data]);

	return <Tabs ariaLabel={t("previous_months")} tabs={tabs} />;
};

export default PreviousMonths;
